module.exports = __webpack_public_path__ + "img/Premium.a6763a5b.svg";